import { Button } from 'blaze-ui/Button'
import Styles from './BrandVisualStyleMedia.module.scss'
import { Upload5 } from 'blaze-ui/icons'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'
import { useImportMediaFiles } from 'hooks/useImportMediaFiles'
import { FileTrigger } from 'components/FileTrigger/FileTrigger'
import { useQueryClient } from 'react-query'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES } from 'screens/Finder/components/views/GalleryView/constants'
import { useState } from 'react'
import { ButtonVariant } from 'blaze-ui/Button/Types'

export interface UploadMoreButtonProps {
  brandKitId: number
  onIsUploadingChange: (isUploading: boolean) => void
  variant?: ButtonVariant
  customText?: string
  className?: string
}

export const UploadMoreButton = ({
  brandKitId,
  onIsUploadingChange,
  variant = 'secondary',
  customText,
  className,
}: UploadMoreButtonProps) => {
  const [uploadProgress, setUploadProgress] = useState(0)
  const { uploadImageFilesWithoutLoadingToast, isUploading } = useImportMediaFiles(
    false,
    () => setUploadProgress(0),
    (progress) => {
      setUploadProgress(progress)
    },
    { forceExtractBackgroundJobSync: true },
  )
  const queryClient = useQueryClient()
  const workspaceId = useCurrentWorkspaceId()

  return (
    <FileTrigger
      accept={ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES}
      allowsMultiple
      onSelect={async (files) => {
        if (!files) return
        onIsUploadingChange(true)
        await uploadImageFilesWithoutLoadingToast(Array.from(files), undefined, {
          brand_kit_id: brandKitId,
        })
        onIsUploadingChange(false)
        queryClient.invalidateQueries(['workspaces', workspaceId, 'brandKits', 'detail', brandKitId])
        queryClient.invalidateQueries({
          queryKey: ['workspaces', workspaceId, 'brandKits', brandKitId, 'mediaFiles', 'list'],
          exact: false,
        })
      }}
    >
      <div className={Styles.uploadMore}>
        <Button
          variant={variant}
          size="xl"
          aria-label="try your own"
          frontIcon={Upload5}
          isDisabled={isUploading}
          className={className}
        >
          {isUploading ? (
            <>
              Uploading
              <LoadingEllipses />
              {uploadProgress.toFixed(0)}%
            </>
          ) : (
            customText || 'Upload More'
          )}
        </Button>
      </div>
    </FileTrigger>
  )
}
